import React from "react";
const bee = require("../assets/LOGO.png");
const help1 = require("../assets/WhoWeHelp/WHO_WE_HELP_1.png");
const help2 = require("../assets/WhoWeHelp/WHO_WE_HELP_2.png");
const help3 = require("../assets/WhoWeHelp/WHO_WE_HELP.png");
const why_us = require("../assets/Why_us_image.jpg");

const Container = () => {
  return (
    <>
      <div className="row" style={{padding: '5px'}}></div>
      <div className="container-md media about-us pl-0 about-us-padd">
        <img
          className="align-self-center mr-4 ml-4"
          width="80"
          src={bee}
          alt="BEE"
        />
        <div className="media-body text-left">
          <h3 className="mt-0 padd-topbtm-10 poppins-bold">About Us</h3>
          <h5 className="mt-0 padd-topbtm-10">
            <span className="rajdhani-bold">"BEE</span>lieve in Flying high!"
          </h5>
          <div className="padd-topbtm-10 text-justify">
            <div>
              Started the brand "BEEHives" to make an honest, ethical impact on
              Product Design Solutions with our Holistic & Innovative Team,
              providing critical Design Solutions for Multiple Products that
              industry needs today.
            </div>
            <div>
              At BEE Hives we motivate to Carve and Reinforce yourself, your
              Careers & Products you Design with strong Technical Training.
            </div>
          </div>
        </div>
      </div>

      <div className="container-md media who-we-help padd-50">
        <div className="container">
          <div className="media-body text-justify">
            <h3 className="mt-0 poppins-bold">Who We Help?</h3>
            <div className="row padd-40">{/* add column assets */}</div>
            <div className="row">
              <div className="col-md-4 col-sm-12">
                <div>
                  <img src={help2} className="m-2" width="80" alt="Product Manufacturers" />
                </div>
                <h5 className="poppins-semi-bold">Product Manufacturers</h5>
                <div>Complete Solutions for</div>
                <div>Product Design</div>
              </div>
              <div className="col-md-4 col-sm-12">
                <div>
                  <img src={help3} className="m-2" width="80" alt="OEM's and Design Firms"/>
                </div>
                <h5 className="poppins-semi-bold">OEM's and Design Firms</h5>
                <div>Consultancy and Staffing</div>
                <div>Solutions</div>
              </div>
              <div className="col-md-4 col-sm-12">
                <div>
                  <img src={help1} className="m-2" width="80" alt="Student & Professionals"/>
                </div>
                <h5 className="poppins-semi-bold">Student & Professionals</h5>
                <div>Design and Domain</div>
                <div>Training</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-md media why-us padd-50">
        <div className="container-md">
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className="media-body text-justify">
                <h3 className="mt-0 padd-topbtm-10 poppins-bold">Why Us?</h3>
                <h5 className="mt-0 padd-topbtm-10">
                  " We <span className="rajdhani-bold">BEE</span>lieve No work is
                  small or Big "
                </h5>
                <p className="padd-topbtm-10">
                  Our Core values defines our Strategy and Approach. We provide
                  best solutions related to Product Design & Consultancy
                  Specialized in SIEMENS NX.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <img src={why_us} width="100%"  className="img-fluid why-us-pic" alt="Why Us"/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Container;
